import React from 'react';
import Icon from '../../../components/AppIcon';

const EmergencyEventsPanel = ({ events, currentLanguage }) => {
  const translations = {
    en: {
      title: 'Emergency Rematch Events',
      noEvents: 'No emergency events',
      resolved: 'Resolved',
      failed: 'Failed',
      resolutionTime: 'Resolution Time',
      minutes: 'min',
      triggerReason: 'Trigger',
      traveler_cancelled: 'Traveler Cancelled',
      trip_changed: 'Trip Changed',
      flight_cancelled: 'Flight Cancelled',
      delay: 'Delay'
    },
    ko: {
      title: '긴급 재매칭 이벤트',
      noEvents: '긴급 이벤트 없음',
      resolved: '해결됨',
      failed: '실패',
      resolutionTime: '해결 시간',
      minutes: '분',
      triggerReason: '트리거',
      traveler_cancelled: '여행자 취소',
      trip_changed: '여행 변경',
      flight_cancelled: '항공편 취소',
      delay: '지연'
    }
  };

  const t = translations?.[currentLanguage];

  const getTriggerConfig = (reason) => {
    const configs = {
      traveler_cancelled: {
        label: t?.traveler_cancelled,
        icon: 'UserX',
        color: 'text-error'
      },
      trip_changed: {
        label: t?.trip_changed,
        icon: 'Calendar',
        color: 'text-warning'
      },
      flight_cancelled: {
        label: t?.flight_cancelled,
        icon: 'PlaneOff',
        color: 'text-error'
      },
      delay: {
        label: t?.delay,
        icon: 'Clock',
        color: 'text-warning'
      }
    };
    return configs?.[reason] || { label: reason, icon: 'AlertTriangle', color: 'text-muted-foreground' };
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="AlertTriangle" size={20} className="text-error" />
        <h2 className="text-lg font-semibold text-foreground">{t?.title}</h2>
      </div>

      <div className="space-y-3 max-h-[500px] overflow-y-auto">
        {events?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">{t?.noEvents}</p>
          </div>
        ) : (
          events?.map((event) => {
            const triggerConfig = getTriggerConfig(event?.triggerReason);
            const isResolved = event?.newDealId !== null;

            return (
              <div
                key={event?.id}
                className="border border-border rounded-lg p-3 hover:bg-accent/5 transition-base"
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className={`w-8 h-8 ${isResolved ? 'bg-success/10' : 'bg-error/10'} rounded-full flex items-center justify-center`}>
                      <Icon
                        name={isResolved ? 'CheckCircle' : 'XCircle'}
                        size={16}
                        className={isResolved ? 'text-success' : 'text-error'}
                      />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground">
                        Deal #{event?.originalDealId?.slice(0, 8)}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {new Date(event?.createdAt)?.toLocaleString(currentLanguage === 'ko' ? 'ko-KR' : 'en-US')}
                      </p>
                    </div>
                  </div>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${isResolved ? 'text-success bg-success/10' : 'text-error bg-error/10'}`}>
                    {isResolved ? t?.resolved : t?.failed}
                  </span>
                </div>

                <div className="flex items-center gap-2 mb-2">
                  <Icon name={triggerConfig?.icon} size={14} className={triggerConfig?.color} />
                  <span className="text-xs text-muted-foreground">
                    {t?.triggerReason}: <span className={`font-medium ${triggerConfig?.color}`}>{triggerConfig?.label}</span>
                  </span>
                </div>

                {isResolved && event?.resolutionTimeMinutes && (
                  <div className="flex items-center gap-2 p-2 bg-success/10 rounded text-xs">
                    <Icon name="Zap" size={12} className="text-success" />
                    <span className="text-success font-medium">
                      {t?.resolutionTime}: {event?.resolutionTimeMinutes} {t?.minutes}
                    </span>
                  </div>
                )}

                {event?.aiSolution?.reasoning && (
                  <div className="mt-2 p-2 bg-muted/30 rounded text-xs text-muted-foreground">
                    <Icon name="Brain" size={12} className="inline mr-1" />
                    {event?.aiSolution?.reasoning?.slice(0, 100)}...
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default EmergencyEventsPanel;